import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TabelaPrecoPipeModule } from '../pipes';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TabelaPrecoMultiselectComponent } from './tabela-preco-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        TabelaPrecoPipeModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TabelaPrecoMultiselectComponent
    ],
    exports: [
        TabelaPrecoMultiselectComponent
    ]
})
export class TabelaPrecoMultiselectModule { }
